import RepositoryFactory from "../../marcom/Apicall/RepositoryFactory";
export default {
  add({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.variable.add(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  update({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.variable.update(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAll({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.variable.getAll(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllDropDown({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.variable.getAllDropDown(
          payload
        );
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getMultiple({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.variable.getMultiple(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
